import { AccountServices } from './domain/Account/Services';
import { UtilsServices } from './domain/Utils/Services';

export default {
  AccountServices,
  UtilsServices,
};
